import { Box, Container } from '@mui/material';
import PastCyclesList from '../../components/InvoiceAndPayroll/PastCycles/PastCyclesList';
import PastCyclesHeader from '../../components/InvoiceAndPayroll/PastCycles/PastCyclesHeader';
import Card from '../../components/Utils/Card';
import { PastCyclesModel } from '../../lib/models/PastCyclesModel';
import Pagination from '../../components/Dashboard/ClinicalReviews/Pagination';
import useGetPaginatedData from '../../lib/hooks/use-pagination-data';
import useTrackPageView from '../../lib/hooks/use-track-page-view';
import { useEffect } from 'react';
import useTrackEvent from '../../lib/hooks/use-track-event';

const PastCycles = () => {
    const trackPageView = useTrackPageView();
    const trackEvent = useTrackEvent();
    const { data, paginationHandler, status, loading } =
        useGetPaginatedData<PastCyclesModel>('invoice-payroll/past');
    //loading, error, status, abortController,
    useEffect(() => {
        trackPageView('Invoice and Payroll - Past Cycles');
    }, [trackPageView]);

    useEffect(() => {
        if (!loading) {
            if (status >= 200 && status < 400 && data) {
                trackEvent('Past Cycles Data', {
                    status: 'success',
                    data: data.data
                });
            } else {
                trackEvent('Past Cycles Data', {
                    status: 'failure',
                    message: 'Past Cycles API call response is neither 200 nor data exist'
                });
            }
        }
    }, [loading, status, data, trackEvent]);

    return (
        <>
            <PastCyclesHeader />
            <Container maxWidth="xl" sx={{ paddingY: 4 }}>
                <Card sx={{ display: 'block' }}>
                    <Box
                        sx={{
                            marginBottom: 2,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}>
                        <Card.Title>Past Cycles</Card.Title>
                        {data && (
                            <Pagination
                                shape="rounded"
                                page={data.page}
                                count={data.totalPages}
                                onChange={paginationHandler}
                            />
                        )}
                    </Box>
                    <Card.Body>
                        {data && (
                            <PastCyclesList
                                data={data.data.map((cycle) => ({
                                    ...cycle,
                                    totalHours: Number(
                                        (
                                            (cycle.ancillaryMinutesNumber +
                                                cycle.reviewMinutesNumber) /
                                            60
                                        ).toFixed(2)
                                    )
                                }))}
                            />
                        )}
                    </Card.Body>
                </Card>
            </Container>
        </>
    );
};

export default PastCycles;
